<template>
  <div class="container mb011">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="-margin-md">ご登録口座へのお振込み</HeadingOne>

    <ErrorsAlert :errors="errors"></ErrorsAlert>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="0" type="mb"></MainWizard>
    </WizardGroup>

    <section>
      <p class="_mb-10">ご登録の口座へお振込みいたします。</p>

      <p class="_mb-0">＜ご注意＞</p>
      <p>
        <BtnText
          v-scroll-to="{ el: '#section_01', offset: -150 }"
          :to="{ path: '#' }"
          class="-underline"
          >下記メンテナンス時間</BtnText
        >は、お申し込みができません。
      </p>
      <p class="txt01">
        また、ご利用されている金融機関が営業時間外の場合にはお振込みができませんので、お手続き完了後にメールおよび会員さま専用サイトのメッセージにてお知らせいたします。その際、お申し込みは予約扱いにはなりません。
      </p>
      <p class="txt01">
        お急ぎの場合は、その他のお借り入れ方法をご利用ください。
      </p>
      <small class="txt01"
        >※ご利用されている金融機関の営業時間は会員さまにてご確認ください。</small
      >

      <div v-if="userData.bank_name">
        <!--<small>※メンテナンス等で<router-link :to="{path: '#'}" v-scroll-to="{el: '#section_01',  offset: -150}" class="-underline">ご利用いただけない場合</router-link>がございます。</small>-->
        <form novalidate @submit.prevent="submitValidateDepositIntoAccount">
          <TableBox class="_mb-md-30 _mb-sm-20 _mt-30">
            <TableBody>
              <TableRow>
                <TableHeader class="-requires"> ご登録の口座 </TableHeader>
                <TableData class="-pctextright">
                  金融機関名：{{ userData.bank_name }}<br />
                  支店名：{{ userData.branch_name }}
                </TableData>
              </TableRow>
              <TableRow>
                <TableHeader> ご利用可能額 </TableHeader>
                <TableData class="-pctextright">
                  {{ numberToCurrency(depositIntoAccount.available_credit) }}
                </TableData>
              </TableRow>
            </TableBody>
          </TableBox>
          <AmountBox
            v-model="validateDepositIntoAccount.amount"
            class="_mb-md-60 _mb-sm-25"
          ></AmountBox>

          <div id="section_01" name="section_01">
            <small
              >※年末年始などの特定日や、メンテナンス時間帯はご利用いただけません。他のお借り入れ方法にてご利用ください。</small
            >
            <HeadingFour class="_mt-10 _mb-10"
              >ご利用いただけない時間帯および特定日</HeadingFour
            >
            <p>
              毎日深夜2:00～4:00<br />
              毎週日曜日19:00～翌月曜日8:00<br />
              年始1月1日～3日、ゴールデンウィーク5月3日～5日
            </p>

            <HeadingFour class="_mt-20 _mb-10"
              >その他のお借り入れ方法</HeadingFour
            >
            <BtnText router-name="mb012" class="-next -ib _mb-md-10 _mb-sm-15"
              >au PAY 残高にチャージ</BtnText
            ><br />
            <BtnText router-name="sv025" target="_blank" class="-next -ib"
              >セブン銀行スマホＡＴＭ</BtnText
            >
          </div>

          <BtngroupDouble class="-margin-lg">
            <template #main>
              <BtnMain
                class="-main"
                @click.prevent="submitValidateDepositIntoAccount"
              >
                確認画面へ
              </BtnMain>
            </template>
            <template #back>
              <BtnBack class="-back -sm" router-name="mb001"> 戻る </BtnBack>
            </template>
          </BtngroupDouble>
        </form>
      </div>

      <div v-else>
        <TableBox class="_mb-md-60 _mb-sm-25 _mt-30">
          <TableBody>
            <TableRow>
              <TableHeader class="-requires"> ご登録の口座 </TableHeader>
              <TableData class="-pctextright -txtdanger">
                ご登録されておりません
              </TableData>
            </TableRow>
            <TableRow>
              <TableHeader> ご利用可能額 </TableHeader>
              <TableData class="-pctextright">
                {{ numberToCurrency(depositIntoAccount.available_credit) }}
              </TableData>
            </TableRow>
          </TableBody>
        </TableBox>

        <div id="section_01" name="section_01" class="_mb-sm-40 _mb-md-60">
          <small
            >※年末年始などの特定日や、メンテナンス時間帯はご利用いただけません。他のお借り入れ方法にてご利用ください。</small
          >
          <HeadingFour class="_mt-10 _mb-10"
            >ご利用いただけない時間帯および特定日</HeadingFour
          >
          <p>
            毎日深夜2:00～4:00<br />
            毎週日曜日19:00～翌月曜日8:00<br />
            年始1月1日～3日、ゴールデンウィーク5月3日～5日
          </p>

          <HeadingFour class="_mt-20 _mb-10"
            >その他のお借り入れ方法</HeadingFour
          >
          <BtnText router-name="mb012" class="-next -ib _mb-md-10 _mb-sm-15"
            >au PAY 残高にチャージ</BtnText
          ><br />
          <BtnText router-name="sv025" target="_blank" class="-next -ib"
            >セブン銀行スマホＡＴＭ</BtnText
          >
        </div>

        <!--<notice-box class="-point">-->
        <!--<notice-header>-->
        <!--<h3 class="heading">口座登録のメリット</h3>-->
        <!--</notice-header>-->
        <!--<notice-body>-->
        <!--<ListGroup class="-normal _mb-20">-->
        <!--<ListItem class="-normal">お借り入れ、ご返済時の手数料は0円</ListItem>-->
        <!--<ListItem class="-normal">毎月のご返済日に、口座からの自動引落としになるため、毎月忘れずにご返済いただけます。</ListItem>-->
        <!--</ListGroup>-->
        <!--<p>口座情報の登録・変更は<BtnText router-name="mb021" class="-underline">こちら</BtnText></p>-->
        <!--</notice-body>-->
        <!--</notice-box>-->

        <CardGroups class="_mb-sm-40 _mb-md-60">
          <CardBox>
            <CardHeader>
              <BtnToggle collapse-target="accordion0" class="-plus">
                <h2 class="heading">
                  お借り入れ・ご返済時に便利な口座登録について
                </h2>
              </BtnToggle>
            </CardHeader>
            <CollapseItem id="accordion0" accordion="accordion" :visible="true">
              <CardBody>
                <ListGroup class="-normal _mb-20">
                  <ListItem class="-normal"
                    >お借り入れ時の口座への振込み手数料、ご返済時の口座からの引落し手数料は0円</ListItem
                  >
                  <ListItem class="-normal"
                    >毎月のご返済日に、口座からの自動引落としになるため、毎月忘れずにご返済いただけます。</ListItem
                  >
                </ListGroup>
                <ListGroup class="-link">
                  <ListItem class="-link" router-name="mb021"
                    >口座情報の登録・変更はこちら</ListItem
                  >
                </ListGroup>
              </CardBody>
            </CollapseItem>
          </CardBox>
        </CardGroups>

        <BtngroupDouble class="-margin-lg">
          <template #main>
            <BtnMain class="-main" router-name="mb021">
              口座登録画面へ
            </BtnMain>
          </template>
          <template #back>
            <BtnBack class="-back -sm" router-name="mb001"> 戻る </BtnBack>
          </template>
        </BtngroupDouble>
      </div>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { initCredentials } from "@/utils/Auth";
import {
  getUserDataForMemberLambdaInvoke,
  depositIntoAccountLambdaInvoke,
  validateDepositIntoAccountLambdaInvoke,
} from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { numberToCurrency } from "@/utils/Filter";
import { goToErrorPage, scrollTop } from "@/utils/Other";

import ErrorsAlert from "@/components/alert/ErrorsAlert";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import HeadingFour from "@/components/heading/HeadingFour";
import BtnText from "@/components/button/BtnText";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import AmountBox from "@/components/box/AmountBox";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtnToggle from "@/components/button/BtnToggle";
import CardBody from "@/components/card/CardBody";
import CardBox from "@/components/card/CardBox";
import CardGroups from "@/components/card/CardGroups";
import CardHeader from "@/components/card/CardHeader";
import CollapseItem from "@/components/collapse/CollapseItem";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb011",
  components: {
    ListItem,
    ListGroup,
    AmountBox,
    BtnBack,
    BtnMain,
    BtngroupDouble,
    BtnText,
    HeadingFour,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    MainWizard,
    WizardGroup,
    HeadingOne,
    ErrorsAlert,
    BtnToggle,
    CardBody,
    CardBox,
    CardGroups,
    CardHeader,
    CollapseItem,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "ご登録口座へのお振込み｜お借り入れ",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,指定口座,振込",
    });

    return {
      numberToCurrency,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "ご登録口座へのお振込み",
          active: true,
        },
      ],
      errors: {},
      isDisabled: false,
      userData: {
        bank_name: "",
        branch_name: "",
        amount: "",
      },
      depositIntoAccount: {
        available_credit: "",
        bank_name: "",
      },
      validateDepositIntoAccount: {
        amount: "",
      },
    };
  },
  mounted() {
    try {
      getUserDataForMemberLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
          this.validateDepositIntoAccount.amount = this.userData.amount;
        })
        .catch((error) => {
          goToErrorPage(error);
        });
      depositIntoAccountLambdaInvoke()
        .then((res) => {
          let resBody = JSON.parse(res.body);
          for (let key in resBody) {
            if (
              Object.prototype.hasOwnProperty.call(this.depositIntoAccount, key)
            ) {
              this.depositIntoAccount[key] = resBody[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitValidateDepositIntoAccount() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        if (this.depositIntoAccount.available_credit < 10000) {
          this.errors = { available_credit: ["credit_zero"] };
          this.isDisabled = false;
          scrollTop();
          return;
        }
        initCredentials()
          .then(() => {
            validateDepositIntoAccountLambdaInvoke(
              this.validateDepositIntoAccount
            )
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.$router.push({ name: "mb013" });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.btn-text {
  font-size: 16px;
  padding: 0;
}
.mb011 {
  > .txt01 {
    color: $danger;
  }
  .-underline {
    text-decoration: underline;
  }
}
</style>
